export enum WithdrawalStatus {
    STATUS_NEW = 1,
    STATUS_PROGRESS = 2,
    STATUS_COMPLETED = 3,
    STATUS_CANCELED = 4,
    STATUS_FAILED = 5,
}